import styled from 'styled-components';

export const AdCardContainer = styled.a`
  font-family: ${({ theme }) => theme.fontFamily};
  background: ${({ theme }) => theme.colors.card};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radiusSm};
  padding: 1.1rem 1.15rem 1.2rem;
  box-shadow: ${({ theme }) => theme.shadowCard};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  text-align: center;
  position: relative;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  box-sizing: border-box;

  ${(props) => {
    if (props.$size === 'small') {
      return `
        min-height: 150px;
        width: 100%;
      `;
    }
    if (props.$size === 'large') {
      return `
        min-height: 400px;
        width: 100%;
      `;
    }
    return `
      min-height: 250px;
      width: 100%;
    `;
  }}

  ${(props) => {
    if (props.$position === 'sidebar') {
      return `
        width: 300px;
        @media (max-width: 1200px) {
          display: none;
        }
      `;
    }
    if (props.$position === 'banner') {
      return `
        width: 100%;
        min-height: 100px;
        margin: 1.5rem 0;
      `;
    }
    if (props.$position === 'inline') {
      return `
        width: 100%;
        margin: 1rem 0;
      `;
    }
    if (props.$position === 'search') {
      return `
        width: 100%;
        min-height: 120px;
        max-width: 420px;
        margin: 0;
      `;
    }
    return '';
  }}
`;

export const AdMedia = styled.div`
  width: 100%;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radiusSm};
  background: ${({ theme }) => theme.colors.border};

  ${(props) => {
    if (props.$position === 'banner' || props.$position === 'search') {
      return `
        aspect-ratio: 2.2 / 1;
        max-height: 260px;
        min-height: 96px;
      `;
    }
    return '';
  }}

  img {
    display: block;
    width: 100%;
    border-radius: 12px;
  }

  ${(props) => {
    if (props.$position === 'banner' || props.$position === 'search') {
      return `
        img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      `;
    }
    return `
      img {
        height: auto;
        max-width: 100%;
        object-fit: cover;
      }
    `;
  }}
`;

export const AdLabel = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: ${({ theme }) => theme.fontClamp.xs};
  color: ${({ theme }) => theme.colors.mutedForeground};
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-weight: 600;
  opacity: 0.85;
  pointer-events: none;
`;

export const AdMeta = styled.div`
  margin-top: 0.65rem;
  width: 100%;
  text-align: left;
`;

export const AdTitle = styled.div`
  font-size: ${({ theme }) => theme.fontClamp.base};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.foreground};
  line-height: 1.35;
`;

export const AdSponsor = styled.div`
  font-size: ${({ theme }) => theme.fontClamp.sm};
  color: ${({ theme }) => theme.colors.mutedForeground};
  margin-top: 0.35rem;
`;

export const AdCta = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  margin-top: 0.85rem;
  padding: 0.5rem 1rem;
  border-radius: calc(${({ theme }) => theme.radiusSm} - 8px);
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primaryForeground};
  font-size: ${({ theme }) => theme.fontClamp.sm};
  font-weight: 700;
`;
